"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectMobileStreamStatus = exports.selectMobileStreamShortInfo = exports.selectMobileStreamPoints = exports.selectMobileStreamData = exports.selectMobileExtremes = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const moment_1 = __importDefault(require("moment"));
const measurementsCalc_1 = require("../utils/measurementsCalc");
const mobileSessionsSelectors_1 = require("./mobileSessionsSelectors");
const mobileStreamSlice_1 = require("./mobileStreamSlice");
const selectMobileStreamData = (state) => state.mobileStream.data;
exports.selectMobileStreamData = selectMobileStreamData;
const selectMobileStreamPoints = (0, toolkit_1.createSelector)([selectMobileStreamData], (mobileStreamState) => mobileStreamState.measurements.map(({ time, value, latitude, longitude }, index) => ({
    id: index,
    lastMeasurementValue: value,
    time,
    point: {
        lat: latitude,
        lng: longitude,
        streamId: mobileStreamState.streamId.toString(),
    },
    notes: mobileStreamState.notes,
})));
exports.selectMobileStreamPoints = selectMobileStreamPoints;
const selectMobileStreamShortInfo = (0, toolkit_1.createSelector)([selectMobileStreamData, mobileSessionsSelectors_1.selectMobileSessionsState], (mobileStreamData, mobileSessionState) => {
    const maxMeasurementValue = Math.max(...mobileStreamData.measurements.map((m) => m.value));
    const minMeasurementValue = Math.min(...mobileStreamData.measurements.map((m) => m.value));
    const mobileSession = mobileSessionState.sessions.find((session) => session.id === mobileStreamData.id);
    const sessionStreamData = mobileSession === null || mobileSession === void 0 ? void 0 : mobileSession.streams[Object.keys(mobileSession.streams)[0]];
    const startTime = mobileStreamData.startTime;
    const endTime = mobileStreamData.endTime;
    const formattedStartTime = startTime
        ? moment_1.default.utc(startTime).format("MM/DD/YYYY HH:mm")
        : mobileStreamSlice_1.initialState.data.startTime;
    const formattedEndTime = endTime
        ? moment_1.default.utc(endTime).format("MM/DD/YYYY HH:mm")
        : mobileStreamSlice_1.initialState.data.endTime;
    return {
        averageValue: (sessionStreamData === null || sessionStreamData === void 0 ? void 0 : sessionStreamData.averageValue) || mobileStreamData.averageValue,
        endTime: formattedEndTime,
        maxMeasurementValue,
        minMeasurementValue,
        profile: mobileStreamData.username,
        sensorName: mobileStreamData.sensorName,
        sessionId: mobileStreamData.id,
        startTime: formattedStartTime,
        title: mobileStreamData.title,
        unitSymbol: mobileStreamData.sensorUnit,
    };
});
exports.selectMobileStreamShortInfo = selectMobileStreamShortInfo;
const selectMobileStreamStatus = (state) => state.mobileStream.status;
exports.selectMobileStreamStatus = selectMobileStreamStatus;
const selectExtremesValues = (state) => state.mobileStream;
const selectMobileExtremes = (0, toolkit_1.createSelector)([selectExtremesValues], (mobileStreamData) => {
    const { averageMeasurementValue, minMeasurementValue, maxMeasurementValue, } = mobileStreamData;
    const min = (0, measurementsCalc_1.isValidValue)(minMeasurementValue)
        ? Math.round(minMeasurementValue)
        : null;
    const max = (0, measurementsCalc_1.isValidValue)(maxMeasurementValue)
        ? Math.round(maxMeasurementValue)
        : null;
    const avg = (0, measurementsCalc_1.isValidValue)(averageMeasurementValue)
        ? Math.round(averageMeasurementValue)
        : null;
    return {
        minMeasurementValue: min,
        maxMeasurementValue: max,
        averageValue: avg,
    };
});
exports.selectMobileExtremes = selectMobileExtremes;
